import { render } from "./treeChild.vue?vue&type=template&id=558ae6ed&scoped=true"
import script from "./treeChild.vue?vue&type=script&lang=js"
export * from "./treeChild.vue?vue&type=script&lang=js"

import "./treeChild.vue?vue&type=style&index=0&id=558ae6ed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558ae6ed"]])

export default __exports__